<template>
  <div>
    <div class="absolute left-[-1px] top-[-24px] z-[12] pr-4">
      <div
        v-tooltip.top="{
          content: $t(addOrPasteTooltip),
          html: true,
        }"
        data-testid="add-block-top"
        class="grid cursor-pointer items-center rounded-t bg-content-1 px-0.5 py-0.5 text-white transition duration-300 hover:bg-content-2"
        @click="addNewOrPaste($event, 'top')"
      >
        <Plus />
      </div>
    </div>
    <div class="absolute bottom-[-24px] left-[-1px] z-[12] pr-4">
      <div
        v-tooltip.top="{
          content: $t(addOrPasteTooltip),
          html: true,
        }"
        data-testid="add-block-bottom"
        class="grid cursor-pointer items-center rounded-b bg-content-1 px-0.5 py-0.5 text-white transition duration-300 hover:bg-content-2"
        @click="addNewOrPaste($event, 'bottom')"
      >
        <Plus />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { Plus } from "@topol/icons";
  import { useDialogsStore } from "@/stores/dialogs";
  import { useMjmlStore } from "@/stores/mjmlStore";
  import getClipboard from "@/utils/getClipboard";
  import { computed } from "vue";

  const props = defineProps({
    blockWidth: {
      type: Number,
      required: true,
    },
    columnPaddingX: {
      type: Number,
      default: 0,
    },
    showPaste: {
      type: Boolean,
      default: false,
    },
  });

  const dialogsStore = useDialogsStore();
  const mjmlStore = useMjmlStore();

  const isMac = computed(() => {
    return navigator.platform.toUpperCase().indexOf("MAC") >= 0;
  });

  const addOrPasteTooltip = computed(() => {
    if (!props.showPaste) {
      return "editor.add_block";
    }

    if (isMac.value) {
      return "editor.add_paste_block_mac";
    }

    return "editor.add_paste_block";
  });

  const openDialog = (direction: "top" | "bottom") => {
    dialogsStore.openBlockDialog({ direction: direction });
  };

  async function paste(direction: "top" | "bottom") {
    const block = await getClipboard();
    if (!block || !("tagName" in block) || block.tagName === "mj-section")
      return;
    setTimeout(() => {
      mjmlStore.addCopiedBlock({ direction: direction, block: block });
    }, 20);
  }

  async function addNewOrPaste(event: any, direction: "top" | "bottom") {
    if ((isMac.value && event.metaKey) || (!isMac.value && event.ctrlKey)) {
      if (props.showPaste) {
        await paste(direction);
      }
    } else {
      openDialog(direction);
    }
  }
</script>

<style scoped>
  /* .add-label {
    background-color: #00d7ca;
    position: absolute;
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 12;
  }

  .label-top {
    top: 0;
    margin-top: -24px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }

  .label-bottom {
    bottom: 0;
    margin-bottom: -24px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  .add-label:hover {
    background-color: #08e8da;
    cursor: pointer;
    transition: background-color 150ms linear;
  } */
</style>
